export default __webpack_public_path__ + "static/media/006.065980a3.jpg";